import { addToCartRest } from "../../../lib/bigcommerce/restfull/apis/cartAPIS";
import useCartStore from "../../../lib/Store/useCartStore";
import useCountryStore from "../../../lib/Store/useCountryStore";

export const quickAddToCartFromOverlay = async (
    productId,
    variantId,
    quantity
) => {
    const productData = {
        selectedProductId: productId,
        selectedVariantId: variantId,
        quantity: quantity,
    };
    try {
        const cartId = useCartStore?.getState()?.cartId;
        const currency = useCountryStore?.getState()?.currency;
        const res = await addToCartRest(productData, cartId, currency);
        if (res?.line_items) useCartStore?.getState()?.updateCartData(res);
        return res;
    } catch (e) {
        return { error: e };
    }
};
